import React from 'react';
import { Globe } from 'lucide-react';

const LanguageSelector = ({ currentLanguage, onLanguageChange, loading = false }) => {
  const languages = [
    { code: 'en', name: 'English', nativeName: 'English' },
    { code: 'hi', name: 'Hindi', nativeName: 'हिंदी' },
    { code: 'ta', name: 'Tamil', nativeName: 'தமிழ்' },
    { code: 'te', name: 'Telugu', nativeName: 'తెలుగు' },
    { code: 'gu', name: 'Gujarati', nativeName: 'ગુજરાતી' },
    { code: 'mr', name: 'Marathi', nativeName: 'मराठी' },
    { code: 'bn', name: 'Bengali', nativeName: 'বাংলা' },
    { code: 'kn', name: 'Kannada', nativeName: 'ಕನ್ನಡ' },
    { code: 'ml', name: 'Malayalam', nativeName: 'മലയാളം' },
    { code: 'pa', name: 'Punjabi', nativeName: 'ਪੰਜਾਬੀ' },
    { code: 'or', name: 'Odia', nativeName: 'ଓଡ଼ିଆ' },
    { code: 'ur', name: 'Urdu', nativeName: 'اردو' }
  ];

  const currentLang = languages.find(lang => lang.code === currentLanguage) || languages[0];

  return (
    <div className="language-selector">
      <div className="language-dropdown">
        <button 
          className="language-trigger"
          disabled={loading}
          aria-label="Select Language"
        >
          <Globe size={16} />
          <span className="language-name">{currentLang.nativeName}</span>
          <span className="dropdown-arrow">▾</span>
        </button>
        
        <div className="language-menu">
          {languages.map((language) => (
            <button
              key={language.code}
              className={`language-option ${currentLanguage === language.code ? 'active' : ''}`}
              onClick={() => onLanguageChange(language.code)}
              disabled={loading}
            >
              <span className="language-native">{language.nativeName}</span>
              <span className="language-english">{language.name}</span>
            </button>
          ))}
        </div>
      </div>

      <style jsx>{`
        .language-selector {
          position: relative;
          display: inline-block;
        }

        .language-dropdown {
          position: relative;
        }

        .language-trigger {
          display: flex;
          align-items: center;
          gap: 8px;
          padding: 8px 12px;
          border: 1px solid #e2e8f0;
          border-radius: 6px;
          background: white;
          color: #374151;
          font-size: 14px;
          font-weight: 500;
          cursor: pointer;
          transition: all 0.2s ease;
          min-width: 120px;
        }

        .language-trigger:hover {
          border-color: #3b82f6;
          box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
        }

        .language-trigger:disabled {
          opacity: 0.6;
          cursor: not-allowed;
        }

        .language-name {
          flex: 1;
          text-align: left;
        }

        .dropdown-arrow {
          color: #6b7280;
          font-size: 12px;
          transition: transform 0.2s ease;
        }

        .language-dropdown:hover .dropdown-arrow {
          transform: rotate(180deg);
        }

        .language-menu {
          position: absolute;
          top: 100%;
          left: 0;
          right: 0;
          background: white;
          border: 1px solid #e2e8f0;
          border-radius: 6px;
          box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
          max-height: 300px;
          overflow-y: auto;
          z-index: 50;
          opacity: 0;
          visibility: hidden;
          transform: translateY(-10px);
          transition: all 0.2s ease;
        }

        .language-dropdown:hover .language-menu {
          opacity: 1;
          visibility: visible;
          transform: translateY(0);
        }

        .language-option {
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          gap: 2px;
          width: 100%;
          padding: 10px 12px;
          border: none;
          background: none;
          text-align: left;
          cursor: pointer;
          transition: background-color 0.2s ease;
        }

        .language-option:hover {
          background-color: #f8fafc;
        }

        .language-option.active {
          background-color: #eff6ff;
          color: #2563eb;
        }

        .language-option:disabled {
          opacity: 0.6;
          cursor: not-allowed;
        }

        .language-native {
          font-weight: 500;
          font-size: 14px;
        }

        .language-english {
          font-size: 12px;
          color: #6b7280;
        }

        .language-option.active .language-english {
          color: #3b82f6;
        }

        /* Scrollbar styling */
        .language-menu::-webkit-scrollbar {
          width: 6px;
        }

        .language-menu::-webkit-scrollbar-track {
          background: #f1f5f9;
        }

        .language-menu::-webkit-scrollbar-thumb {
          background: #cbd5e1;
          border-radius: 3px;
        }

        .language-menu::-webkit-scrollbar-thumb:hover {
          background: #94a3b8;
        }
      `}</style>
    </div>
  );
};

export default LanguageSelector;
